import {
  setUserAuthState,
  setInitialState
} from '../session/actions';
import cookie from 'js-cookie';
import {
  GATEWAY_SERVICES_TIMEOUT_ERROR
} from './types';

const AFFILIATE_NUMBER_KEY: string = "affiliate-number";
const AFFILIATE_ID_KEY: string = "affiliate-id";
const LOGGED_OUT: string = 'logged-out';
const AUTHENTICATED_BY_OCTA: string = "authenticated_by_octa";
const COOKIE_PATH = '/';

export const gatewayServicesRequest = (payload: any) => ({
  type: GATEWAY_SERVICES_TIMEOUT_ERROR,
  payload
});

export const getServicesErrorObj = (error: any) =>
  (dispatch: Function) => {
    if (error?.response?.status === 502 || (error?.response?.status === 504 && error?.response?.data?.code !== '1510')) {
      dispatch(gatewayServicesRequest(true));
      dispatch(resetSession());
    } else {
      dispatch(gatewayServicesRequest(false));
    }
  };

export const resetSession = () => (dispatch: Function) =>
  new Promise((resolve) => {
    cookie.remove(AFFILIATE_NUMBER_KEY, { path: COOKIE_PATH });
    cookie.remove(AFFILIATE_ID_KEY, { path: COOKIE_PATH });

    sessionStorage.removeItem(AFFILIATE_NUMBER_KEY);
    sessionStorage.removeItem(AFFILIATE_ID_KEY);
    sessionStorage.removeItem(AUTHENTICATED_BY_OCTA);
    sessionStorage.removeItem(LOGGED_OUT);

    dispatch(setUserAuthState(false));
    dispatch(setInitialState());
    resolve('');
  });

export type ServicesDowntimeAction = {
  type: string,
  payload?: any
};
